const legacySite = window.site.legacyPageBaseUrl;
const coreSite = window.site.corePageBaseUrl;
export const routes = {
    "account_ReprimandedForCheating": () => ({ relative: "/account/multiuse/detected", absolute: coreSite + "/account/multiuse/detected"}),
    "account_ResetMyPassword": () => ({ relative: "/account/resetmypassword", absolute: coreSite + "/account/resetmypassword"}),
    "account_SignIn": () => ({ relative: "/account/signin", absolute: coreSite + "/account/signin"}),
    "advancing_InvitationLanding": (secret: string) => {
        const replace = (input: string, secret: string) => input.replace("{secret}", secret.toString());
        return {
            relative: replace("/advancing/invitation/{secret}", secret),
            absolute: replace(coreSite + "/advancing/invitation/{secret}", secret)
        };
    },
    "advancing_Provide": (secret: string) => {
        const replace = (input: string, secret: string) => input.replace("{secret}", secret.toString());
        return {
            relative: replace("/advancing/invitation/{secret}/provide", secret),
            absolute: replace(coreSite + "/advancing/invitation/{secret}/provide", secret)
        };
    },
    "advancingApprove_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/advancing/approve/{key}", key),
            absolute: replace(legacySite + "/advancing/approve/{key}", key)
        };
    },
    "advancingFormTemplate_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/advancingtemplate/detail/{key}", key),
            absolute: replace(coreSite + "/advancingtemplate/detail/{key}", key)
        };
    },
    "advancingFormTemplate_List": () => ({ relative: "/advancingtemplate", absolute: coreSite + "/advancingtemplate"}),
    "advancingFormTemplate_New": () => ({ relative: "/advancingtemplate/new", absolute: coreSite + "/advancingtemplate/new"}),
    "airport_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/airport/{key}", key),
            absolute: replace(coreSite + "/airport/{key}", key)
        };
    },
    "airport_List": () => ({ relative: "/airport", absolute: coreSite + "/airport"}),
    "article_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/article/{key}/edit", key),
            absolute: replace(coreSite + "/article/{key}/edit", key)
        };
    },
    "article_List": (section: string) => {
        const replace = (input: string, section: string) => input.replace("{section}", section.toString());
        return {
            relative: replace("/article/{section}", section),
            absolute: replace(coreSite + "/article/{section}", section)
        };
    },
    "articleCategory_List": (section: string) => {
        const replace = (input: string, section: string) => input.replace("{section}", section.toString());
        return {
            relative: replace("/articlecategory/{section}", section),
            absolute: replace(coreSite + "/articlecategory/{section}", section)
        };
    },
    "artistRider_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/artistrider/{key}", key),
            absolute: replace(coreSite + "/artistrider/{key}", key)
        };
    },
    "artistRider_List": () => ({ relative: "/artistrider", absolute: coreSite + "/artistrider"}),
    "artistRider_New": () => ({ relative: "/artistrider/new", absolute: coreSite + "/artistrider/new"}),
    "bankAccount_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/bankaccount/{key}", key),
            absolute: replace(coreSite + "/bankaccount/{key}", key)
        };
    },
    "bankAccount_List": () => ({ relative: "/bankaccount", absolute: coreSite + "/bankaccount"}),
    "bankAccount_New": () => ({ relative: "/bankaccount/new", absolute: coreSite + "/bankaccount/new"}),
    "bookkeeping_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/bookkeeping/{key}", key),
            absolute: replace(coreSite + "/bookkeeping/{key}", key)
        };
    },
    "bookkeeping_List": () => ({ relative: "/bookkeeping", absolute: coreSite + "/bookkeeping"}),
    "bookkeeping_New": () => ({ relative: "/bookkeeping/new", absolute: coreSite + "/bookkeeping/new"}),
    "brand_Edit": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/brand/{key}/edit", key),
            absolute: replace(coreSite + "/brand/{key}/edit", key)
        };
    },
    "brand_List": () => ({ relative: "/brand", absolute: coreSite + "/brand"}),
    "businessCentralProject_List": () => ({ relative: "/businesscentralproject", absolute: coreSite + "/businesscentralproject"}),
    "checklistPresetItem_List": () => ({ relative: "/checklistpreset", absolute: coreSite + "/checklistpreset"}),
    "client_AccessStatus": () => ({ relative: "/client/access/status", absolute: coreSite + "/client/access/status"}),
    "client_DetailAdminOne": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/adminone/client/{key}", key),
            absolute: replace(coreSite + "/adminone/client/{key}", key)
        };
    },
    "client_ListAdminOne": () => ({ relative: "/adminone/client", absolute: coreSite + "/adminone/client"}),
    "client_NewAdminOne": () => ({ relative: "/adminone/client/new", absolute: coreSite + "/adminone/client/new"}),
    "clientOnboarding_Landing": (secret: string) => {
        const replace = (input: string, secret: string) => input.replace("{secret}", secret.toString());
        return {
            relative: replace("/clientonboarding/{secret}", secret),
            absolute: replace(coreSite + "/clientonboarding/{secret}", secret)
        };
    },
    "company_Artist_List": () => ({ relative: "/artist", absolute: coreSite + "/artist"}),
    "company_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/company/{key}", key),
            absolute: replace(coreSite + "/company/{key}", key)
        };
    },
    "company_List": () => ({ relative: "/company", absolute: coreSite + "/company"}),
    "company_Merge": (key: number, mergekey: number) => {
        const replace = (input: string, key: number, mergekey: number) => input.replace("{key}", key.toString()).replace("{mergekey}", mergekey.toString());
        return {
            relative: replace("/company/{key}/merge/{mergekey}", key, mergekey),
            absolute: replace(coreSite + "/company/{key}/merge/{mergekey}", key, mergekey)
        };
    },
    "company_Promoter_List": () => ({ relative: "/promoter", absolute: coreSite + "/promoter"}),
    "company_Venue_List": () => ({ relative: "/venue", absolute: coreSite + "/venue"}),
    "contact_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/contact/{key}", key),
            absolute: replace(coreSite + "/contact/{key}", key)
        };
    },
    "contact_List": () => ({ relative: "/contact", absolute: coreSite + "/contact"}),
    "contact_Merge": (key: number, mergekey: number) => {
        const replace = (input: string, key: number, mergekey: number) => input.replace("{key}", key.toString()).replace("{mergekey}", mergekey.toString());
        return {
            relative: replace("/contact/{key}/merge/{mergekey}", key, mergekey),
            absolute: replace(coreSite + "/contact/{key}/merge/{mergekey}", key, mergekey)
        };
    },
    "content_Gdpr": () => ({ relative: "/content/gdpr", absolute: coreSite + "/content/gdpr"}),
    "content_LicenceTerms": () => ({ relative: "/content/enduserlicenceterms", absolute: coreSite + "/content/enduserlicenceterms"}),
    "content_SecurityPolicy": () => ({ relative: "/content/securitypolicy", absolute: coreSite + "/content/securitypolicy"}),
    "contract_Copy": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/contract/copy/{key}", key),
            absolute: replace(coreSite + "/contract/copy/{key}", key)
        };
    },
    "contract_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/contract/detail/{key}", key),
            absolute: replace(coreSite + "/contract/detail/{key}", key)
        };
    },
    "contract_ESign": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/contract/{key}/esign", key),
            absolute: replace(coreSite + "/contract/{key}/esign", key)
        };
    },
    "contract_List": () => ({ relative: "/contract", absolute: coreSite + "/contract"}),
    "contract_New": () => ({ relative: "/contract/new", absolute: coreSite + "/contract/new"}),
    "contract_Totals": () => ({ relative: "/contract/total", absolute: coreSite + "/contract/total"}),
    "costCenter_Edit": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/costcenter/{key}/edit", key),
            absolute: replace(coreSite + "/costcenter/{key}/edit", key)
        };
    },
    "costCenter_List": () => ({ relative: "/costcenter", absolute: coreSite + "/costcenter"}),
    "country_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/country/{key}", key),
            absolute: replace(coreSite + "/country/{key}", key)
        };
    },
    "country_List": () => ({ relative: "/country", absolute: coreSite + "/country"}),
    "creditTransaction_List": () => ({ relative: "/credittransaction", absolute: coreSite + "/credittransaction"}),
    "culture_List": () => ({ relative: "/culture", absolute: coreSite + "/culture"}),
    "dashboard": () => ({ relative: "/", absolute: coreSite + "/"}),
    "diagnostic_Page_Health": () => ({ relative: "/diagnostic/5915ab75-f6a9-4514-abce-b01b476c9944/health", absolute: coreSite + "/diagnostic/5915ab75-f6a9-4514-abce-b01b476c9944/health"}),
    "emailMessage_PublicDownload": (secret: string) => {
        const replace = (input: string, secret: string) => input.replace("{secret}", secret.toString());
        return {
            relative: replace("/download/{secret}", secret),
            absolute: replace(coreSite + "/download/{secret}", secret)
        };
    },
    "embedShowsWizard": () => ({ relative: "/wizard/embedshow", absolute: coreSite + "/wizard/embedshow"}),
    "eSign_ForMeList": () => ({ relative: "/esign/forme", absolute: coreSite + "/esign/forme"}),
    "eSign_Landing": (secret: string) => {
        const replace = (input: string, secret: string) => input.replace("{secret}", secret.toString());
        return {
            relative: replace("/esign/invitation/{secret}", secret),
            absolute: replace(coreSite + "/esign/invitation/{secret}", secret)
        };
    },
    "excelTemplate_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/exceltemplate/detail/{key}", key),
            absolute: replace(coreSite + "/exceltemplate/detail/{key}", key)
        };
    },
    "excelTemplate_List": (mainarea: server.dto.MainAreas) => {
        const replace = (input: string, mainarea: server.dto.MainAreas) => input.replace("{mainarea}", mainarea.toString());
        return {
            relative: replace("/exceltemplate/{mainarea}", mainarea),
            absolute: replace(coreSite + "/exceltemplate/{mainarea}", mainarea)
        };
    },
    "excelTemplate_New": (mainarea: server.dto.MainAreas) => {
        const replace = (input: string, mainarea: server.dto.MainAreas) => input.replace("{mainarea}", mainarea.toString());
        return {
            relative: replace("/exceltemplate/{mainarea}/new", mainarea),
            absolute: replace(coreSite + "/exceltemplate/{mainarea}/new", mainarea)
        };
    },
    "exchangeRate_List": () => ({ relative: "/exchangerate", absolute: coreSite + "/exchangerate"}),
    "externalCalendar_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/externalcalendar/{key}", key),
            absolute: replace(coreSite + "/externalcalendar/{key}", key)
        };
    },
    "externalCalendar_List": () => ({ relative: "/externalcalendar", absolute: coreSite + "/externalcalendar"}),
    "externalCalendar_New": () => ({ relative: "/externalcalendar/new", absolute: coreSite + "/externalcalendar/new"}),
    "externalEvent_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/externalevent/{key}", key),
            absolute: replace(coreSite + "/externalevent/{key}", key)
        };
    },
    "externalIdentity_ChooseUser": () => ({ relative: "/externalidentity/chooseuser", absolute: coreSite + "/externalidentity/chooseuser"}),
    "externalUser_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/user/external/detail/{key}", key),
            absolute: replace(coreSite + "/user/external/detail/{key}", key)
        };
    },
    "externalUser_List": () => ({ relative: "/user/external", absolute: coreSite + "/user/external"}),
    "extractorSession_list": () => ({ relative: "/extractorsession", absolute: coreSite + "/extractorsession"}),
    "file_Overview": () => ({ relative: "/file", absolute: coreSite + "/file"}),
    "flight_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/flight/detail/{key}", key),
            absolute: replace(coreSite + "/flight/detail/{key}", key)
        };
    },
    "flight_List": () => ({ relative: "/flight", absolute: coreSite + "/flight"}),
    "freeFieldCategory_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/freefieldcategory/detail/{key}", key),
            absolute: replace(coreSite + "/freefieldcategory/detail/{key}", key)
        };
    },
    "freeFieldCategory_List": (mainarea: server.dto.MainAreas) => {
        const replace = (input: string, mainarea: server.dto.MainAreas) => input.replace("{mainarea}", mainarea.toString());
        return {
            relative: replace("/freefieldcategory/{mainarea}", mainarea),
            absolute: replace(coreSite + "/freefieldcategory/{mainarea}", mainarea)
        };
    },
    "freeFieldDefinition_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/freefielddetails/detail/{key}", key),
            absolute: replace(coreSite + "/freefielddetails/detail/{key}", key)
        };
    },
    "freeFieldDefinition_New": (mainarea: server.dto.MainAreas) => {
        const replace = (input: string, mainarea: server.dto.MainAreas) => input.replace("{mainarea}", mainarea.toString());
        return {
            relative: replace("/freefielddetails/{mainarea}/new", mainarea),
            absolute: replace(coreSite + "/freefielddetails/{mainarea}/new", mainarea)
        };
    },
    "freeFieldProfile_Detail": (environment: string, key: number) => {
        const replace = (input: string, environment: string, key: number) => input.replace("{environment}", environment.toString()).replace("{key}", key.toString());
        return {
            relative: replace("/freefieldprofile/{environment}/detail/{key}", environment, key),
            absolute: replace(coreSite + "/freefieldprofile/{environment}/detail/{key}", environment, key)
        };
    },
    "freeFieldProfile_List": (environment: string) => {
        const replace = (input: string, environment: string) => input.replace("{environment}", environment.toString());
        return {
            relative: replace("/freefieldprofile/{environment}", environment),
            absolute: replace(coreSite + "/freefieldprofile/{environment}", environment)
        };
    },
    "freeFieldProfile_New": (environment: string) => {
        const replace = (input: string, environment: string) => input.replace("{environment}", environment.toString());
        return {
            relative: replace("/freefieldprofile/{environment}/new", environment),
            absolute: replace(coreSite + "/freefieldprofile/{environment}/new", environment)
        };
    },
    "groundTransport_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/groundtransport/detail/{key}", key),
            absolute: replace(coreSite + "/groundtransport/detail/{key}", key)
        };
    },
    "groundTransport_List": () => ({ relative: "/groundtransport", absolute: coreSite + "/groundtransport"}),
    "iCalendarFeed_Help": (secret: string) => {
        const replace = (input: string, secret: string) => input.replace("{secret}", secret.toString());
        return {
            relative: replace("/ical/{secret}/help", secret),
            absolute: replace(coreSite + "/ical/{secret}/help", secret)
        };
    },
    "iCalendarTemplate_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/icalendartemplate/detail/{key}", key),
            absolute: replace(coreSite + "/icalendartemplate/detail/{key}", key)
        };
    },
    "iCalendarTemplate_List": () => ({ relative: "/icalendartemplate", absolute: coreSite + "/icalendartemplate"}),
    "iCalendarTemplate_New": () => ({ relative: "/icalendartemplate/new", absolute: coreSite + "/icalendartemplate/new"}),
    "internalUser_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/user/internal/detail/{key}", key),
            absolute: replace(coreSite + "/user/internal/detail/{key}", key)
        };
    },
    "internalUser_List": () => ({ relative: "/user/internal", absolute: coreSite + "/user/internal"}),
    "internalUser_Tansfer": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/user/internal/transfer/{key}", key),
            absolute: replace(coreSite + "/user/internal/transfer/{key}", key)
        };
    },
    "invoice_List": () => ({ relative: "/invoice", absolute: coreSite + "/invoice"}),
    "invoice_SalesDataExport": () => ({ relative: "/invoiceexport", absolute: coreSite + "/invoiceexport"}),
    "invoice_Totals": () => ({ relative: "/invoice/total", absolute: coreSite + "/invoice/total"}),
    "invoiceV1_Copy": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/invoice/copy/{key}", key),
            absolute: replace(coreSite + "/invoice/copy/{key}", key)
        };
    },
    "invoiceV1_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/invoice/detail/{key}", key),
            absolute: replace(coreSite + "/invoice/detail/{key}", key)
        };
    },
    "invoiceV1_MakeCredit": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/invoice/makecredit/{key}", key),
            absolute: replace(coreSite + "/invoice/makecredit/{key}", key)
        };
    },
    "invoiceV1_New": () => ({ relative: "/invoice/new", absolute: coreSite + "/invoice/new"}),
    "invoiceV2_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/invoicev2/detail/{key}", key),
            absolute: replace(coreSite + "/invoicev2/detail/{key}", key)
        };
    },
    "invoiceV2_Landing": (secret: string) => {
        const replace = (input: string, secret: string) => input.replace("{secret}", secret.toString());
        return {
            relative: replace("/invoicev2/invitation/{secret}", secret),
            absolute: replace(coreSite + "/invoicev2/invitation/{secret}", secret)
        };
    },
    "mergeField_List": (mainarea: server.dto.MainAreas) => {
        const replace = (input: string, mainarea: server.dto.MainAreas) => input.replace("{mainarea}", mainarea.toString());
        return {
            relative: replace("/mergefields/{mainarea}", mainarea),
            absolute: replace(coreSite + "/mergefields/{mainarea}", mainarea)
        };
    },
    "messageTemplate_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/template/message/detail/{key}", key),
            absolute: replace(coreSite + "/template/message/detail/{key}", key)
        };
    },
    "messageTemplate_List": (messagetemplatetype: string) => {
        const replace = (input: string, messagetemplatetype: string) => input.replace("{messagetemplatetype}", messagetemplatetype.toString());
        return {
            relative: replace("/template/message/{messagetemplatetype}", messagetemplatetype),
            absolute: replace(coreSite + "/template/message/{messagetemplatetype}", messagetemplatetype)
        };
    },
    "notification_List": () => ({ relative: "/notification", absolute: coreSite + "/notification"}),
    "payment_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/payment/{key}", key),
            absolute: replace(coreSite + "/payment/{key}", key)
        };
    },
    "payment_List": () => ({ relative: "/payment", absolute: coreSite + "/payment"}),
    "personal_ChangeName": () => ({ relative: "/personalsettings/change-name", absolute: coreSite + "/personalsettings/change-name"}),
    "personal_ChangePassword": () => ({ relative: "/personalsettings/change-password", absolute: coreSite + "/personalsettings/change-password"}),
    "personal_ChangeSecretQuestion": () => ({ relative: "/personalsettings/change-secret-question", absolute: coreSite + "/personalsettings/change-secret-question"}),
    "personal_ConnectedAccount_List": () => ({ relative: "/personalsettings/connected-accounts", absolute: coreSite + "/personalsettings/connected-accounts"}),
    "personal_EmailSettings": () => ({ relative: "/personalsettings/email-settings", absolute: coreSite + "/personalsettings/email-settings"}),
    "personal_FavoriteSubject_List": () => ({ relative: "/personalsettings/favorite-subjects", absolute: coreSite + "/personalsettings/favorite-subjects"}),
    "personal_ICalendarFeed_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/personalsettings/icalendarfeed/{key}", key),
            absolute: replace(coreSite + "/personalsettings/icalendarfeed/{key}", key)
        };
    },
    "personal_ICalendarFeed_List": () => ({ relative: "/personalsettings/icalendar-feeds", absolute: coreSite + "/personalsettings/icalendar-feeds"}),
    "personal_SettingMenu": () => ({ relative: "/personalsettings", absolute: coreSite + "/personalsettings"}),
    "personal_SignatureSettings": () => ({ relative: "/personalsettings/signature-settings", absolute: coreSite + "/personalsettings/signature-settings"}),
    "planning_Availability": () => ({ relative: "/planning/availability", absolute: coreSite + "/planning/availability"}),
    "planning_Itinerary": () => ({ relative: "/planning/itinerary", absolute: coreSite + "/planning/itinerary"}),
    "planning_Map": () => ({ relative: "/planning/map", absolute: coreSite + "/planning/map"}),
    "planning_Month": () => ({ relative: "/planning/month", absolute: coreSite + "/planning/month"}),
    "planning_Quarter": () => ({ relative: "/planning/quarter", absolute: coreSite + "/planning/quarter"}),
    "planning_Week": () => ({ relative: "/planning/week", absolute: coreSite + "/planning/week"}),
    "preference_Defaults": () => ({ relative: "/personalsettings/defaults", absolute: coreSite + "/personalsettings/defaults"}),
    "preference_FeatureConfig": () => ({ relative: "/personalsettings/feature-configure", absolute: coreSite + "/personalsettings/feature-configure"}),
    "preference_NotificationSettings": () => ({ relative: "/personalsettings/notification-settings", absolute: coreSite + "/personalsettings/notification-settings"}),
    "preference_RegionalSettings": () => ({ relative: "/personalsettings/language-and-region", absolute: coreSite + "/personalsettings/language-and-region"}),
    "productGroup_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/productgroup/{key}", key),
            absolute: replace(coreSite + "/productgroup/{key}", key)
        };
    },
    "productGroup_List": () => ({ relative: "/productgroup", absolute: coreSite + "/productgroup"}),
    "productGroup_New": () => ({ relative: "/productgroup/new", absolute: coreSite + "/productgroup/new"}),
    "production_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/production/{key}", key),
            absolute: replace(coreSite + "/production/{key}", key)
        };
    },
    "production_List": () => ({ relative: "/production", absolute: coreSite + "/production"}),
    "productTemplate_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/producttemplate/{key}", key),
            absolute: replace(coreSite + "/producttemplate/{key}", key)
        };
    },
    "productTemplate_List": () => ({ relative: "/producttemplate", absolute: coreSite + "/producttemplate"}),
    "productTemplate_New": () => ({ relative: "/producttemplate/new", absolute: coreSite + "/producttemplate/new"}),
    "purchaseAgreement_Copy": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/purchaseagreement/copy/{key}", key),
            absolute: replace(coreSite + "/purchaseagreement/copy/{key}", key)
        };
    },
    "purchaseAgreement_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/purchaseagreement/detail/{key}", key),
            absolute: replace(coreSite + "/purchaseagreement/detail/{key}", key)
        };
    },
    "purchaseAgreement_ESign": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/purchaseagreement/{key}/esign", key),
            absolute: replace(coreSite + "/purchaseagreement/{key}/esign", key)
        };
    },
    "purchaseAgreement_List": () => ({ relative: "/purchaseagreement", absolute: coreSite + "/purchaseagreement"}),
    "purchaseAgreement_New": () => ({ relative: "/purchaseagreement/new", absolute: coreSite + "/purchaseagreement/new"}),
    "purchaseAgreement_Totals": () => ({ relative: "/purchaseagreement/total", absolute: coreSite + "/purchaseagreement/total"}),
    "quote_Copy": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/quote/copy/{key}", key),
            absolute: replace(coreSite + "/quote/copy/{key}", key)
        };
    },
    "quote_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/quote/detail/{key}", key),
            absolute: replace(coreSite + "/quote/detail/{key}", key)
        };
    },
    "quote_ESign": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/quote/{key}/esign", key),
            absolute: replace(coreSite + "/quote/{key}/esign", key)
        };
    },
    "quote_List": () => ({ relative: "/quote", absolute: coreSite + "/quote"}),
    "quote_New": () => ({ relative: "/quote/new", absolute: coreSite + "/quote/new"}),
    "quote_Totals": () => ({ relative: "/quote/total", absolute: coreSite + "/quote/total"}),
    "show_Copy": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/show/{key}/copy", key),
            absolute: replace(coreSite + "/show/{key}/copy", key)
        };
    },
    "show_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/show/{key}", key),
            absolute: replace(coreSite + "/show/{key}", key)
        };
    },
    "show_FromWebform": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/show/{key}/fromwebform", key),
            absolute: replace(coreSite + "/show/{key}/fromwebform", key)
        };
    },
    "show_List": () => ({ relative: "/show", absolute: coreSite + "/show"}),
    "show_LockShows": () => ({ relative: "/show/lock", absolute: coreSite + "/show/lock"}),
    "show_New": () => ({ relative: "/show/new", absolute: coreSite + "/show/new"}),
    "show_NewContract": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/show/{key}/contract", key),
            absolute: replace(coreSite + "/show/{key}/contract", key)
        };
    },
    "show_NewInvoice": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/show/{key}/invoice", key),
            absolute: replace(coreSite + "/show/{key}/invoice", key)
        };
    },
    "show_NewPurchaseAgreement": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/show/{key}/purchaseagreement", key),
            absolute: replace(coreSite + "/show/{key}/purchaseagreement", key)
        };
    },
    "show_NewQuote": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/show/{key}/quote", key),
            absolute: replace(coreSite + "/show/{key}/quote", key)
        };
    },
    "show_Total": () => ({ relative: "/show/total", absolute: coreSite + "/show/total"}),
    "stateAlias_Unmapped": () => ({ relative: "/statealias", absolute: coreSite + "/statealias"}),
    "status_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/status/detail/{key}", key),
            absolute: replace(coreSite + "/status/detail/{key}", key)
        };
    },
    "status_List": (mainarea: server.dto.MainAreas) => {
        const replace = (input: string, mainarea: server.dto.MainAreas) => input.replace("{mainarea}", mainarea.toString());
        return {
            relative: replace("/status/{mainarea}", mainarea),
            absolute: replace(coreSite + "/status/{mainarea}", mainarea)
        };
    },
    "status_New": (mainarea: server.dto.MainAreas) => {
        const replace = (input: string, mainarea: server.dto.MainAreas) => input.replace("{mainarea}", mainarea.toString());
        return {
            relative: replace("/status/{mainarea}/new", mainarea),
            absolute: replace(coreSite + "/status/{mainarea}/new", mainarea)
        };
    },
    "subscription_Detail": () => ({ relative: "/subscription", absolute: coreSite + "/subscription"}),
    "subscription_PaymentSetupComplete": () => ({ relative: "/subscription/payment-setup-complete", absolute: coreSite + "/subscription/payment-setup-complete"}),
    "systemSetting_Config": () => ({ relative: "/systemsettings/config", absolute: coreSite + "/systemsettings/config"}),
    "systemSetting_ICalendarFeed_Detail": (usertoclientid: number, key: number) => {
        const replace = (input: string, usertoclientid: number, key: number) => input.replace("{usertoclientid}", usertoclientid.toString()).replace("{key}", key.toString());
        return {
            relative: replace("/user/{usertoclientid}/icalendarfeed/{key}", usertoclientid, key),
            absolute: replace(coreSite + "/user/{usertoclientid}/icalendarfeed/{key}", usertoclientid, key)
        };
    },
    "systemSetting_Menu": () => ({ relative: "/systemsettings", absolute: coreSite + "/systemsettings"}),
    "systemWideFiles_List": () => ({ relative: "/file/systemwide", absolute: coreSite + "/file/systemwide"}),
    "tag_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/tag/detail/{key}", key),
            absolute: replace(coreSite + "/tag/detail/{key}", key)
        };
    },
    "tag_List": (mainarea: server.dto.MainAreas) => {
        const replace = (input: string, mainarea: server.dto.MainAreas) => input.replace("{mainarea}", mainarea.toString());
        return {
            relative: replace("/tag/{mainarea}", mainarea),
            absolute: replace(coreSite + "/tag/{mainarea}", mainarea)
        };
    },
    "tag_New": (mainarea: server.dto.MainAreas) => {
        const replace = (input: string, mainarea: server.dto.MainAreas) => input.replace("{mainarea}", mainarea.toString());
        return {
            relative: replace("/tag/{mainarea}/new", mainarea),
            absolute: replace(coreSite + "/tag/{mainarea}/new", mainarea)
        };
    },
    "taskManager_List": () => ({ relative: "/taskmanager", absolute: coreSite + "/taskmanager"}),
    "templateSetting_Menu": () => ({ relative: "/templatesettings", absolute: coreSite + "/templatesettings"}),
    "train_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/train/detail/{key}", key),
            absolute: replace(coreSite + "/train/detail/{key}", key)
        };
    },
    "train_List": () => ({ relative: "/train", absolute: coreSite + "/train"}),
    "user_DetailAdminOne": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/adminone/user/{key}", key),
            absolute: replace(coreSite + "/adminone/user/{key}", key)
        };
    },
    "user_ListAdminOne": () => ({ relative: "/adminone/user", absolute: coreSite + "/adminone/user"}),
    "userAction_List": () => ({ relative: "/useraction", absolute: coreSite + "/useraction"}),
    "userTaskTemplate_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/defaulttasks/detail/{key}", key),
            absolute: replace(coreSite + "/defaulttasks/detail/{key}", key)
        };
    },
    "userTaskTemplate_List": () => ({ relative: "/defaulttasks", absolute: coreSite + "/defaulttasks"}),
    "webform_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/webform/{key}", key),
            absolute: replace(coreSite + "/webform/{key}", key)
        };
    },
    "webform_List": () => ({ relative: "/webform", absolute: coreSite + "/webform"}),
    "wordTemplate_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/wordtemplate/detail/{key}", key),
            absolute: replace(coreSite + "/wordtemplate/detail/{key}", key)
        };
    },
    "wordTemplate_List": (mainarea: server.dto.MainAreas) => {
        const replace = (input: string, mainarea: server.dto.MainAreas) => input.replace("{mainarea}", mainarea.toString());
        return {
            relative: replace("/wordtemplate/{mainarea}", mainarea),
            absolute: replace(coreSite + "/wordtemplate/{mainarea}", mainarea)
        };
    },
    "wordTemplate_New": (mainarea: server.dto.MainAreas) => {
        const replace = (input: string, mainarea: server.dto.MainAreas) => input.replace("{mainarea}", mainarea.toString());
        return {
            relative: replace("/wordtemplate/{mainarea}/new", mainarea),
            absolute: replace(coreSite + "/wordtemplate/{mainarea}/new", mainarea)
        };
    },
    "wordTemplateForListView_Detail": (key: number) => {
        const replace = (input: string, key: number) => input.replace("{key}", key.toString());
        return {
            relative: replace("/wordtemplateforlistview/detail/{key}", key),
            absolute: replace(coreSite + "/wordtemplateforlistview/detail/{key}", key)
        };
    },
    "wordTemplateForListView_List": (mainarea: server.dto.MainAreas) => {
        const replace = (input: string, mainarea: server.dto.MainAreas) => input.replace("{mainarea}", mainarea.toString());
        return {
            relative: replace("/wordtemplateforlistview/{mainarea}", mainarea),
            absolute: replace(coreSite + "/wordtemplateforlistview/{mainarea}", mainarea)
        };
    },
    "wordTemplateForListView_New": (mainarea: server.dto.MainAreas) => {
        const replace = (input: string, mainarea: server.dto.MainAreas) => input.replace("{mainarea}", mainarea.toString());
        return {
            relative: replace("/wordtemplateforlistview/{mainarea}/new", mainarea),
            absolute: replace(coreSite + "/wordtemplateforlistview/{mainarea}/new", mainarea)
        };
    }
};